// Footer Accordion - Smooth height animation (same as FAQ)
class FooterAccordion extends HTMLElement {
  constructor() {
    super();

    this.details = this.querySelector('details');
    this.summary = this.querySelector('summary');
    this.content = this.querySelector('.footer__accordion-content');
    this.summaryIsEmpty = this.summary ? this.summary.textContent.trim().length == 0 : false;

    this.isAnimating = false;

    // Only enable animation on mobile
    if (this.details && this.summary && this.content && theme.config.mqlSmall) {
      // Prevent native toggle so we can animate manually
      this.summary.addEventListener(
        'click',
        (event) => {
          event.preventDefault();
          this.toggle();
        },
        { passive: false },
      );
    } else {
      // Desktop: prevent any click action on heading, accordion should always be open
      if (this.details && this.summary) {
        this.summary.addEventListener('click', (event) => {
          event.preventDefault();
        }, { passive: false });
      }
    }

    // Handle responsive changes
    document.addEventListener('matchSmall', () => {
      if (this.content && !this.summaryIsEmpty) {
        // Re-initialize animation on mobile
        if (!this.details.hasAttribute('open')) {
          this.content.style.height = '0px';
          this.content.style.opacity = '0';
          this.content.style.transform = 'translateY(-8px)';
        }
      }
    });
    document.addEventListener('unmatchSmall', () => {
      // Desktop: always open
      if (this.details) {
        this.details.setAttribute('open', true);
        if (this.content) {
          this.content.style.height = 'auto';
          this.content.style.opacity = '1';
          this.content.style.transform = 'translateY(0)';
        }
      }
    });

    // Initial state
    if (!theme.config.mqlSmall || this.summaryIsEmpty) {
      if (this.details) {
        this.details.setAttribute('open', true);
        if (this.summaryIsEmpty && this.details) {
          this.details.setAttribute('empty', true);
        }
        // Set initial open state for content
        if (this.content && this.details.hasAttribute('open')) {
          this.content.style.height = 'auto';
          this.content.style.opacity = '1';
          this.content.style.transform = 'translateY(0)';
          this.classList.add('is-open');
        }
      }
    } else {
      // Mobile: check if should be open by default (first accordion)
      const isFirstAccordion = this.details && this.details.hasAttribute('open');
      if (this.details && !isFirstAccordion && this.dataset.open == undefined) {
        this.details.removeAttribute('open');
        if (this.content) {
          this.content.style.height = '0px';
          this.content.style.opacity = '0';
          this.content.style.transform = 'translateY(-8px)';
        }
      } else if (isFirstAccordion && this.content) {
        // First accordion should be open
        this.content.style.height = 'auto';
        this.content.style.opacity = '1';
        this.content.style.transform = 'translateY(0)';
        this.classList.add('is-open');
      }
    }
  }

  onSummaryClick(event) {
    event.preventDefault();
    if (this.details) {
      this.details.hasAttribute('open')
        ? this.details.removeAttribute('open')
        : this.details.setAttribute('open', true);
    }
  }

  toggle() {
    if (!this.details || !this.content || this.isAnimating) return;

    if (this.details.open) {
      this.collapse();
    } else {
      this.expand();
    }
  }

  expand() {
    if (this.isAnimating) return;
    this.isAnimating = true;

    const content = this.content;

    // Ensure starting from collapsed state
    content.style.height = '0px';
    content.style.opacity = '0';
    content.style.transform = 'translateY(-8px)';

    // Mark as open for styling and accessibility
    this.details.open = true;
    this.classList.add('is-open');

    const targetHeight = content.scrollHeight;

    // Trigger transition in next frame
    requestAnimationFrame(() => {
      content.style.height = `${targetHeight}px`;
      content.style.opacity = '1';
      content.style.transform = 'translateY(0)';
    });

    const onTransitionEnd = (event) => {
      if (event.target !== content || event.propertyName !== 'height') return;

      content.style.height = 'auto';
      content.removeEventListener('transitionend', onTransitionEnd);
      this.isAnimating = false;
    };

    content.addEventListener('transitionend', onTransitionEnd);
  }

  collapse() {
    if (this.isAnimating) return;
    this.isAnimating = true;

    const content = this.content;

    // From auto height -> fixed px height so we can animate to 0
    const startHeight = content.scrollHeight;
    content.style.height = `${startHeight}px`;
    content.style.opacity = '1';
    content.style.transform = 'translateY(0)';

    // Trigger transition in next frame
    requestAnimationFrame(() => {
      content.style.height = '0px';
      content.style.opacity = '0';
      content.style.transform = 'translateY(-8px)';
    });

    const onTransitionEnd = (event) => {
      if (event.target !== content || event.propertyName !== 'height') return;

      this.details.open = false;
      this.classList.remove('is-open');

      content.removeEventListener('transitionend', onTransitionEnd);
      this.isAnimating = false;
    };

    content.addEventListener('transitionend', onTransitionEnd);
  }
}

customElements.define('footer-accordion', FooterAccordion);